import TSettingUsersAdd from './index.vue';

TSettingUsersAdd.install = app => {
  app.component(TSettingUsersAdd.name, TSettingUsersAdd);
};

export default TSettingUsersAdd;
